export interface CancelStripeSubscriptionResponse {
  success: boolean;
  message?: string;
  // Platform of the active subscription. Populated when the subscription is NOT
  // on Stripe (e.g. APPLE / GOOGLE), so the UI can render platform-specific
  // cancellation instructions instead of a misleading error.
  platform?: "STRIPE" | "APPLE" | "GOOGLE";
}

/**
 * Cancel user's active Stripe subscription
 *
 * @param accessAuth0Token - Auth0 access token
 * @returns Response with success status and message
 */
export const cancelStripeSubscription = async (accessAuth0Token: string): Promise<CancelStripeSubscriptionResponse> => {
  const url = `${process.env.REACT_APP_BACKEND_URL}/payments/cancel-stripe-subscription`;
  console.log("🌐 cancelStripeSubscription - URL:", url);
  console.log("🌐 cancelStripeSubscription - Token present:", !!accessAuth0Token);

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessAuth0Token}`,
      },
      credentials: "include",
    });

    console.log("📡 cancelStripeSubscription - Response status:", response.status);
    const data = (await response.json()) as CancelStripeSubscriptionResponse;
    console.log("📡 cancelStripeSubscription - Response data:", data);

    if (!response.ok) {
      return {
        success: false,
        message: data?.message || "Failed to cancel subscription",
      };
    }
    return data;
  } catch (error) {
    console.error("❌ cancelStripeSubscription error:", error);
    return {
      success: false,
      message: "Network error. Please check your connection and try again.",
    };
  }
};
